import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { Text, Tooltip, useMeasure } from '@frameio/vapor';
import type { NotificationGroupInfo } from '../types';
import { useHeaderData } from './useHeaderData';

const measureContainerStyle = {
  height: '0',
  visibility: 'hidden',
  overflowWrap: 'break-word',
} as CSSProperties;

const StyledTooltip = styled(Tooltip)`
  word-break: break-word;
`;
const MAX_HEIGHT = 60;

export function Header({ id, notificationType }: NotificationGroupInfo) {
  const data = useHeaderData({
    id,
    notificationType,
  });

  const [refForMeasure, { height }] = useMeasure();

  if (!data) return null;

  const { text, assetName, shouldTruncateUserName, firstItem } = data;
  return (
    <StyledTooltip
      placement="bottom"
      shouldRender={height > MAX_HEIGHT && Boolean(assetName)}
      title={assetName}
    >
      <div>
        <div style={measureContainerStyle}>
          <Text
            ref={refForMeasure}
            color="primary"
            fontWeight="medium"
            variant="primary"
          >
            {text}
          </Text>
        </div>
        {shouldTruncateUserName && firstItem && 'content' in firstItem && (
          <Text
            aria-hidden={true}
            as="p"
            color="primary"
            fontWeight="medium"
            truncate={true}
            variant="primary"
          >
            {firstItem.content}
          </Text>
        )}
        <Text
          as="p"
          color="primary"
          data-testid="notification-header"
          fontWeight="medium"
          truncate={shouldTruncateUserName ? 3 : 4}
          variant="primary"
        >
          {text}
        </Text>
      </div>
    </StyledTooltip>
  );
}
